
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_v54xe_9",
  "root-horizontal": "awsui_root-horizontal_o08jm_v54xe_43",
  "root-vertical": "awsui_root-vertical_o08jm_v54xe_48",
  "control": "awsui_control_o08jm_v54xe_53",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_v54xe_60",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_v54xe_60",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_v54xe_63",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_v54xe_63",
  "ghost": "awsui_ghost_o08jm_v54xe_67",
  "inline-label": "awsui_inline-label_o08jm_v54xe_82",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_v54xe_107",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_v54xe_112"
};
  